import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d503efa2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-part" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "header-content" }
const _hoisted_4 = { class: "header-media-group" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { style: {"text-align":"center","position":"absolute","top":"35px"} }
const _hoisted_7 = { href: "/" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  href: "/c2000/app/",
  class: "header-logo"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "header-form" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "m-2" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" })
], -1))
const _hoisted_16 = { class: "header-widget-group" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-sync-alt" }, null, -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1))
const _hoisted_20 = {
  key: 0,
  href: "#",
  class: "header-widget",
  title: "Configuraciones"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-cog" }, null, -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-check" }, null, -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-key" }, null, -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  key: 3,
  class: "header-widget header-cart",
  title: "Cartlist"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-shopping-basket" }, null, -1))
const _hoisted_29 = {
  key: 0,
  style: {"margin-left":"22%","margin-right":"20%","margin-top":"-10px"}
}
const _hoisted_30 = ["value"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Cambio de contraseña", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-md-5" }
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Contraseña Actual", -1))
const _hoisted_38 = { class: "blog-widget-form" }
const _hoisted_39 = { class: "col-md-5" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Nueva Contraseña", -1))
const _hoisted_41 = { class: "blog-widget-form" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_43 = {
  class: "col-md-2",
  style: {"align-content":"center","align-items":"center","margin-top":"23px"}
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Buscar cliente", -1))
const _hoisted_45 = { class: "row" }
const _hoisted_46 = { class: "col-md-6" }
const _hoisted_47 = { class: "form-group" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Código", -1))
const _hoisted_49 = { class: "blog-widget-form" }
const _hoisted_50 = { class: "modal-table" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Seleccionar"),
    /*#__PURE__*/_createElementVNode("th", null, "Código"),
    /*#__PURE__*/_createElementVNode("th", null, "Razón Social"),
    /*#__PURE__*/_createElementVNode("th", null, "RNC")
  ])
], -1))
const _hoisted_52 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "header-user",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navigateToPag && _ctx.navigateToPag(...args))),
            style: {"display":"flex","flex-direction":"column","align-items":"center","justify-content":"center","position":"relative"}
          }, [
            _createElementVNode("img", {
              src: _ctx.logoUser,
              alt: "user"
            }, null, 8, _hoisted_5),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.UserLogued?.Nombre ?  '' : 'Login'), 1)
          ]),
          _createElementVNode("a", _hoisted_7, [
            _createElementVNode("img", {
              src: _ctx.logoEmpresa,
              alt: "logo"
            }, null, 8, _hoisted_8)
          ]),
          _createElementVNode("button", {
            class: "header-src",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.viewFitler && _ctx.viewFitler(...args)))
          }, _hoisted_10)
        ]),
        _createElementVNode("a", _hoisted_11, [
          _createElementVNode("img", {
            src: _ctx.logoEmpresa,
            alt: "logo"
          }, null, 8, _hoisted_12)
        ]),
        _createElementVNode("a", {
          href: "#",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.navigateToPag && _ctx.navigateToPag(...args))),
          class: "header-widget",
          title: "My Account"
        }, [
          _createElementVNode("img", {
            src: _ctx.logoUser,
            alt: "user"
          }, null, 8, _hoisted_13),
          _createElementVNode("span", null, _toDisplayString(_ctx.UserLogued?.Nombre ?? "Iniciar Session"), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.textFilter) = $event)),
            onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setglobalFilter())),
            placeholder: "Buscar aqui..."
          }, null, 544), [
            [_vModelText, _ctx.textFilter]
          ]),
          _hoisted_15
        ]),
        _createElementVNode("div", _hoisted_16, [
          (_ctx.UserLogued && _ctx.UserLogued?.Tipo_usuario == 'administrador')
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "header-widget",
                title: "Recargar Imagenes ",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.reloadImages()))
              }, _hoisted_18))
            : _createCommentVNode("", true),
          _hoisted_19,
          _createVNode(_component_router_link, { to: 'setting' }, {
            default: _withCtx(() => [
              (_ctx.UserLogued && _ctx.UserLogued?.Tipo_usuario == 'administrador')
                ? (_openBlock(), _createElementBlock("a", _hoisted_20, _hoisted_22))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (
              _ctx.UserLogued?.Nombre &&
              (_ctx.UserLogued?.Tipo_usuario == 'administrador' ||
                _ctx.UserLogued?.Tipo_usuario == 'representante') &&
              _ctx.UserLogued?.puedeSeleccionarEmpresa
            )
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: "#",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showModal = true)),
                class: "header-widget",
                title: "buscar un Cliente"
              }, _hoisted_24))
            : _createCommentVNode("", true),
          (_ctx.UserLogued?.Nombre && _ctx.UserLogued?.Tipo_usuario == 'administrador')
            ? (_openBlock(), _createElementBlock("a", {
                key: 2,
                href: "#",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showModalPassword = true)),
                class: "header-widget",
                title: "Cambiar Contraseña"
              }, _hoisted_26))
            : _createCommentVNode("", true),
          (!_ctx.isChecout())
            ? (_openBlock(), _createElementBlock("button", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("sup", null, _toDisplayString(_ctx.cantidadItem), 1),
                _createElementVNode("span", null, [
                  _createTextVNode("Carrito "),
                  _createElementVNode("small", null, "$" + _toDisplayString(_ctx.formatoDecimal(_ctx.valorTotal)), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.UserLogued?.Nombre && _ctx.UserLogued?.Empresas[0]?.ClienteData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _createElementVNode("input", {
              type: "text",
              class: "form-control",
              value: _ctx.UserLogued?.Empresas[0]?.ClienteData?.RazonSoc,
              name: "nombreCliente",
              id: "nombreCliente"
            }, null, 8, _hoisted_30)
          ]))
        : _createCommentVNode("", true),
      _hoisted_31
    ]),
    _createVNode(_component_Modal, { showModal: _ctx.showModalPassword }, {
      default: _withCtx(() => [
        _createElementVNode("button", {
          class: "close-button",
          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.closeChagePass && _ctx.closeChagePass(...args)))
        }, "X"),
        _hoisted_32,
        _hoisted_33,
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _createElementVNode("div", _hoisted_38, [
                _withDirectives(_createElementVNode("input", {
                  type: "password",
                  placeholder: "Contraseña Actual",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.claveActual) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.claveActual]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _hoisted_40,
            _createElementVNode("div", _hoisted_41, [
              _withDirectives(_createElementVNode("input", {
                type: "password",
                placeholder: "Nueva Contraseña",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.claveNueva) = $event))
              }, null, 512), [
                [_vModelText, _ctx.claveNueva]
              ])
            ])
          ]),
          _hoisted_42,
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.SaveCambioPass && _ctx.SaveCambioPass(...args)))
            }, " Guardar ")
          ])
        ])
      ]),
      _: 1
    }, 8, ["showModal"]),
    _createVNode(_component_Modal, { showModal: _ctx.showModal }, {
      default: _withCtx(() => [
        _createElementVNode("button", {
          class: "close-button",
          onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }, "X"),
        _hoisted_44,
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _hoisted_48,
              _createElementVNode("div", _hoisted_49, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: "Buscar...",
                  onKeyup: _cache[13] || (_cache[13] = _withKeys(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["enter"])),
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.searchTerm) = $event))
                }, null, 544), [
                  [_vModelText, _ctx.searchTerm]
                ]),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args))),
                  class: "icofont-search-1"
                })
              ])
            ])
          ])
        ]),
        _createElementVNode("table", _hoisted_50, [
          _hoisted_51,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clients, (client, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", null, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _withModifiers(($event: any) => (_ctx.selectClient(client)), ["prevent"])
                  }, "Seleccionar", 8, _hoisted_52)
                ]),
                _createElementVNode("td", null, _toDisplayString(client.Codclte), 1),
                _createElementVNode("td", null, _toDisplayString(client.RazonSoc), 1),
                _createElementVNode("td", null, _toDisplayString(client.Rnc), 1)
              ]))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["showModal"])
  ]))
}